<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import SettingsLayout from '../SettingsLayout.vue';
import WebhookRow from './WebhookRow.vue';
import SecretCreatedModal from './SecretCreatedModal.vue';

export default {
  components: {
    SettingsLayout,
    NextButton,
    BaseSettingsHeader,
    WebhookRow,
    SecretCreatedModal,
  },
  data() {
    return {
      showDeleteConfirmationPopup: false,
      showSecretModal: false,
      selectedWebhook: {},
      rotatedWebhook: null,
    };
  },
  computed: {
    ...mapGetters({
      webhooks: 'kaptionDeliveryWebhooks/getWebhooks',
      uiFlags: 'kaptionDeliveryWebhooks/getUIFlags',
    }),
    tableHeaders() {
      return [
        this.$t('KAPTION_DELIVERY_WEBHOOKS.LIST.TABLE_HEADER.NAME'),
        this.$t('KAPTION_DELIVERY_WEBHOOKS.LIST.TABLE_HEADER.EVENTS'),
        this.$t('KAPTION_DELIVERY_WEBHOOKS.LIST.TABLE_HEADER.SECRET'),
        this.$t('KAPTION_DELIVERY_WEBHOOKS.LIST.TABLE_HEADER.STATUS'),
        this.$t('KAPTION_DELIVERY_WEBHOOKS.LIST.TABLE_HEADER.ACTIONS'),
      ];
    },
  },
  mounted() {
    this.$store.dispatch('kaptionDeliveryWebhooks/get');
  },
  methods: {
    navigateToCreate() {
      this.$router.push({
        name: 'settings_kaption_delivery_webhooks_new',
      });
    },
    openDeletePopup(webhook) {
      this.showDeleteConfirmationPopup = true;
      this.selectedWebhook = webhook;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    hideSecretModal() {
      this.showSecretModal = false;
      this.rotatedWebhook = null;
    },
    async confirmDeletion() {
      this.closeDeletePopup();
      try {
        await this.$store.dispatch(
          'kaptionDeliveryWebhooks/revoke',
          this.selectedWebhook.id
        );
        useAlert(
          this.$t('KAPTION_DELIVERY_WEBHOOKS.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(this.$t('KAPTION_DELIVERY_WEBHOOKS.DELETE.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.fetchingList"
    :loading-message="$t('KAPTION_DELIVERY_WEBHOOKS.LOADING')"
    :no-records-message="$t('KAPTION_DELIVERY_WEBHOOKS.LIST.404')"
    :no-records-found="!webhooks.length"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('KAPTION_DELIVERY_WEBHOOKS.HEADER')"
        :description="$t('KAPTION_DELIVERY_WEBHOOKS.DESCRIPTION')"
      >
        <template #actions>
          <NextButton
            blue
            icon="i-lucide-circle-plus"
            :label="$t('KAPTION_DELIVERY_WEBHOOKS.HEADER_BTN_TXT')"
            @click="navigateToCreate"
          />
        </template>
      </BaseSettingsHeader>
    </template>
    <template #body>
      <table class="min-w-full divide-y divide-n-weak">
        <thead>
          <th
            v-for="thHeader in tableHeaders"
            :key="thHeader"
            class="py-4 ltr:pr-4 rtl:pl-4 text-left font-semibold text-n-slate-11 last:text-right last:pr-4"
          >
            {{ thHeader }}
          </th>
        </thead>
        <tbody class="divide-y divide-n-weak flex-1 text-n-slate-12">
          <WebhookRow
            v-for="webhook in webhooks"
            :key="webhook.id"
            :webhook="webhook"
            @delete="openDeletePopup"
          />
        </tbody>
      </table>
    </template>

    <SecretCreatedModal
      v-if="showSecretModal"
      :webhook="rotatedWebhook"
      @close="hideSecretModal"
    />

    <woot-delete-modal
      v-model:show="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('KAPTION_DELIVERY_WEBHOOKS.DELETE.CONFIRM.TITLE')"
      :message="
        $t('KAPTION_DELIVERY_WEBHOOKS.DELETE.CONFIRM.MESSAGE', {
          webhookName: selectedWebhook.name,
        })
      "
      :confirm-text="$t('KAPTION_DELIVERY_WEBHOOKS.DELETE.CONFIRM.YES')"
      :reject-text="$t('KAPTION_DELIVERY_WEBHOOKS.DELETE.CONFIRM.NO')"
    />
  </SettingsLayout>
</template>
